import Icon from './icon';
export { ICONS } from './icon';
export type { IconType } from './icon';
export default Icon;

// SVG ICONS
export { default as IconCheckIn } from './check-in';
export { default as IconChevronLightRight } from './chevron-light-right';
export { default as IconChevronLightLeft } from './chevron-light-left';
export { default as IconExclusiveAmenities } from './exclusive-amenities';
export { default as IconFlightArrival } from './flight-arrival';
export { default as IconHamburgerMenu } from './hamburger-menu';
export { default as IconHotel } from './hotel';
export { default as IconItineraryDefault } from './itinerary-default';
export { default as IconItineraryNew } from './itinerary_new';
export { default as IconTravel } from './travel';
export { default as IconYourSleep } from './your-sleep';
export { default as IconChevronDown } from './chevron-down';
export { default as IconChevronUp } from './chevron-up';
export { default as IconInformation } from './information';
export { default as IconWarning } from './warning';
export { default as IconCollapse } from './collapse';
export { default as IconCollapseUp } from './collapse-up';
export { default as IconAlert } from './alert';
export { default as IconCheckmark } from './checkmark-icon';
export { default as Information } from './information';
export { default as IconClose } from './close-alt';
export { default as IconRoom } from './room';
export { default as IconPillows } from './pillows';
export { default as IconBeds } from './beds';
export { default as IconCloseAlt } from './close-alt';
export { default as IconTransportation } from './transportation';
export { default as IconServicesAndAmenities } from './services-and-amenities';
export { default as IconChat } from './default-circle';
export { default as IconShoppingCart } from './shopping_cart';
export { default as IconShoppingCartOutline } from './shopping-cart-outline';
export { default as IconRecommendations } from './recommendations';
export { default as IconResortActivities } from './resort_activities';
export { default as IconWeddings } from './weddings';
export { default as IconBusinessCenter } from './business_center';
export { default as IconTime } from './time';
export { default as IconPropertyInfo } from './property-info';
export { default as IconOccupancy } from './occupancy';
export { default as IconLocationPin } from './location-pin';
export { default as IconArrowCollapse } from './arrow-collapse';
export { default as IconPlus } from './plus';
export { default as IconAdd } from './add';
export { default as IconAccessibility } from './accessibility';
export { default as IconActivities } from './activities';
export { default as IconAdventure } from './adventure';
export { default as IconAfricaMiddleEast } from './africa-middle-east';
export { default as IconAirlineCheckIn } from './airline_check_in';
export { default as IconAlarm } from './alarm';
export { default as IconArtsCulture } from './arts_culture';
export { default as IconAsiaPacific } from './asia-pacific';
export { default as IconAwardWinningSpa } from './award_winning_spa';
export { default as IconBanquet } from './banquet';
export { default as IconBathroom } from './bathroom';
export { default as IconBeach } from './beach';
export { default as IconBellcartLuggage } from './bellcart_luggage';
export { default as IconBiodiversityAndConservation } from './biodiversity_and_conservation';
export { default as IconBlizzard } from './blizzard';
export { default as IconBlowingSnow } from './blowing_snow';
export { default as IconBoardroom } from './boardroom';
export { default as IconBook } from './book';
export { default as IconBrightness } from './brightness';
export { default as IconBusinessCentre } from './business_centre';
export { default as IconCallAltInverted } from './call_alt_inverted';
export { default as IconCallAlt } from './call_alt';
export { default as IconCallCircleOutline } from './call_circle_outline';
export { default as IconCall } from './call';
export { default as IconCaretDown } from './caret_down';
export { default as IconCaret } from './caret';
export { default as IconCaretUp } from './caret_up';
export { default as IconCastle } from './castle';
export { default as IconCentralSouthAmerica } from './central-south-america';
export { default as IconChatDefaultCircle } from './chat_default_circle';
export { default as IconChatNotificationLarge } from './chat_notification_large';
export { default as IconChatNotification } from './chat_notification';
export { default as IconChatOutline } from './chat_outline';
export { default as IconCheckmarkFill } from './checkmark_fill';
export { default as IconCheckmarkOutline } from './checkmark_outline';
export { default as IconCheckmarkSimple } from './checkmark_simple';
export { default as IconCheckOut } from './check_out';
export { default as IconChevronLeft } from './chevron_left';
export { default as IconChevronRight } from './chevron_right';
export { default as IconClassroom } from './classroom';
export { default as IconCloseCircle } from './close_circle';
export { default as IconCloudyFog } from './cloudy_fog';
export { default as IconCloudySunnyBreaks } from './cloudy_sunny_breaks';
export { default as IconCloudy } from './cloudy';
export { default as IconCocktail } from './cocktail';
export { default as IconCold } from './cold';
export { default as IconComfort } from './comfort';
export { default as IconCommercialFlight } from './commercial_flight';
export { default as IconCondo } from './condo';
export { default as IconContactEmail } from './contact_email';
export { default as IconContactPhone } from './contact_phone';
export { default as IconCovidTesting } from './covid_testing';
export { default as IconCreditCard } from './credit_card';
export { default as IconCulinaryExperience } from './culinary_experience';
export { default as IconDairyFree } from './dairy_free';
export { default as IconDecor } from './decor';
export { default as IconDesktop } from './desktop';
export { default as IconDetachedHouse } from './detached_house';
export { default as IconDetails } from './details';
export { default as IconDiningReservation } from './dining_reservation';
export { default as IconDining } from './dining';
export { default as IconDiversityInclusionAndBelonging } from './diversity_inclusion_and_belonging';
export { default as IconDivingSnorkeling } from './diving_snorkeling';
export { default as IconDocumentsAndDownloads } from './documents_and_downloads';
export { default as IconDouban } from './douban';
export { default as IconDownload } from './download';
export { default as IconDressCode } from './dress_code';
export { default as IconDrizzle } from './drizzle';
export { default as IconEdit } from './edit';
export { default as IconEggFree } from './egg_free';
export { default as IconEmailFill } from './email_fill';
export { default as IconEmail } from './email';
export { default as IconEnergyCarbonAndWaterReduction } from './energy_carbon_and_water_reduction';
export { default as IconEnergyReduction } from './energy_reduction';
export { default as IconEnhancedCleaning } from './enhanced_cleaning';
export { default as IconEnvironmentalPrograms } from './environmental_programs';
export { default as IconEnvironment } from './environment';
export { default as IconEurope } from './europe';
export { default as IconExclusiveAmenitiesFilled } from './exclusive_amenities_filled';
export { default as IconExclusiveOffer } from './exclusive_offer';
export { default as IconExclusivesBuyouts } from './exclusives-buyouts';
export { default as IconExperience } from './experience';
export { default as IconExpressPressing } from './express_pressing';
export { default as IconExtension } from './extension';
export { default as IconEyeClosed } from './eye_closed';
export { default as IconEyeOpen } from './eye_open';
export { default as IconEyeOutline } from './eye_outline';
export { default as IconFacebook } from './facebook';
export { default as IconFacebookTag } from './facebook_tag';
export { default as IconFamily } from './family';
export { default as IconFaqs } from './faqs';
export { default as IconFestiveMenu } from './festive_menu';
export { default as IconFilter } from './filter';
export { default as IconFindHotelStatus } from './find_hotel_status';
export { default as IconFitnessFacilities } from './fitness_facilities';
export { default as IconFlightDeparture } from './flight_departure';
export { default as IconFlightInfo } from './flight_info';
export { default as IconFloorplan } from './floorplan';
export { default as IconFogPatches } from './fog-patches';
export { default as IconFog } from './fog';
export { default as IconFoursquare } from './foursquare';
export { default as IconFreezingDrizzle } from './freezing_drizzle';
export { default as IconFreezingFog } from './freezing_fog';
export { default as IconFreezingRain } from './freezing_rain';
export { default as IconGalleryExternal } from './gallery_external';
export { default as IconGallery } from './gallery';
export { default as IconGlutenFree } from './gluten_free';
export { default as IconGolf } from './golf';
export { default as IconGoogleplus } from './googleplus';
export { default as IconGovernance } from './governance';
export { default as IconHamburger } from './hamburger';
export { default as IconHamburguerSmall } from './hamburguer_small';
export { default as IconHandshake } from './handshake';
export { default as IconHazeVariableClouds } from './haze_variable_clouds';
export { default as IconHealthAndSafety } from './health_and_safety';
export { default as IconHeart } from './heart';
export { default as IconHollowSquare } from './hollow_square';
export { default as IconHorsebackRiding } from './horseback_riding';
export { default as IconHot } from './hot';
export { default as IconIcePellets } from './ice_pellets';
export { default as IconInRoomDining } from './in-room_dining';
export { default as IconInstagram } from './instagram';
export { default as IconIsolatedShowers } from './isolated_showers';
export { default as IconItemAdd } from './item_add';
export { default as IconItemRemove } from './item_remove';
export { default as IconItineraryNotification } from './itinerary_notification';
export { default as IconItinerary } from './itinerary';
export { default as IconKids } from './kids';
export { default as IconKitchen } from './kitchen';
export { default as IconLateCheckout } from './late_checkout';
export { default as IconLaundry } from './laundry';
export { default as IconLessSign } from './less_sign';
export { default as IconLightSnow } from './light_snow';
export { default as IconList } from './list';
export { default as IconLocationPinBrand } from './location_pin_brand';
export { default as IconLocationPinLargeFill } from './location_pin_large_fill';
export { default as IconLocationPinSmallFill } from './location_pin_small_fill';
export { default as IconLocationPinSmall } from './location_pin_small';
export { default as IconLock } from './lock';
export { default as IconLuxuryBathProducts } from './luxury_bath_products';
export { default as IconMailDefaultCircle } from './mail_default_circle';
export { default as IconMainlyClear } from './mainly_clear';
export { default as IconMaintenance } from './maintenance';
export { default as IconMeetingsAndEvents } from './meetings_and_events';
export { default as IconMobileKey } from './mobile_key';
export { default as IconMobile } from './mobile';
export { default as IconMore } from './more';
export { default as IconMountain } from './mountain';
export { default as IconMultilingualConcierge } from './multilingual_concierge';
export { default as IconMyNeighborhood } from './my_neighborhood';
export { default as IconNightClearCloudy } from './night_clear_cloudy';
export { default as IconNightCloudyClear } from './night_cloudy_clear';
export { default as IconNightCloudy } from './night_cloudy';
export { default as IconNightIsolatedShowers } from './night_isolated_showers';
export { default as IconNightScatteredFlurries } from './night_scattered_flurries';
export { default as IconNightScatteredShowers } from './night_scattered_showers';
export { default as IconNightSnowRain } from './night_snow_rain';
export { default as IconNightThunderstormChance } from './night_thunderstorm_chance';
export { default as IconNoAvailableDate } from './no_available_date';
export { default as IconNorthAmerica } from './north-america';
export { default as IconNotes } from './notes';
export { default as IconNutFree } from './nut_free';
export { default as IconOffers } from './offers';
export { default as IconOrderGrocery } from './order_grocery';
export { default as IconOutbound } from './outbound';
export { default as IconOutdoorExperience } from './outdoor_experience';
export { default as IconOutdoorFunctionSpace } from './outdoor-function-space';
export { default as IconPaginationLine } from './pagination_line';
export { default as IconParking } from './parking';
export { default as IconPartlyCloudy } from './partly_cloudy';
export { default as IconPauseButtonLarge } from './pause_button_large';
export { default as IconPauseButtonSmall } from './pause_button_small';
export { default as IconPlayButtonSmall } from './play_button_small';
export { default as IconPerson } from './person';
export { default as IconPet } from './pet';
export { default as IconPhotoAndVideo } from './photo_and_video';
export { default as IconPillow } from './pillow';
export { default as IconPinterest } from './pinterest';
export { default as IconPlusSign } from './plus_sign';
export { default as IconPoolAlt } from './pool_alt';
export { default as IconPool } from './pool';
export { default as IconPrAndHotel } from './pr_and_hotel';
export { default as IconPremiumWifi } from './premium_wifi';
export { default as IconPressreader } from './pressreader';
export { default as IconPrivateFlight } from './private_flight';
export { default as IconPrivateJet } from './private_jet';
export { default as IconPrivateRetreats } from './private_retreats';
export { default as IconPurchasingPractices } from './purchasing_practices';
export { default as IconQq } from './qq';
export { default as IconQuotationMarksL } from './quotation_marks_l';
export { default as IconQuotationMarksOutline } from './quotation_marks_outline';
export { default as IconQuotationMarksS } from './quotation_marks_s';
export { default as IconRain } from './rain';
export { default as IconRamdanMenu } from './ramdan_menu';
export { default as IconReception } from './reception';
export { default as IconRefreshments } from './refreshments';
export { default as IconResidenceALaCarte } from './residence_a_la_carte';
export { default as IconResidenceDining } from './residence_dining';
export { default as IconResidenceMyBuilding } from './residence_my_building';
export { default as IconResidenceServices } from './residence_services';
export { default as IconResidence } from './residence';
export { default as IconResort } from './resort';
export { default as IconResortUrban } from './resort-urban';
export { default as IconRoomCleaning } from './room_cleaning';
export { default as IconRoomUpgrade } from './room_upgrade';
export { default as IconSafetyAndSecurityInverted } from './safety_and_security_inverted';
export { default as IconSafetyAndSecurity } from './safety_and_security';
export { default as IconScatteredFlurries } from './scattered_flurries';
export { default as IconScatteredShowers } from './scattered_showers';
export { default as IconSearch } from './search';
export { default as IconSettings } from './settings';
export { default as IconShoe } from './shoe';
export { default as IconShopping } from './shopping';
export { default as IconShoppingLock } from './shopping-lock';
export { default as IconShowers } from './showers';
export { default as IconShuttleBusSchedule } from './shuttle_bus_schedule';
export { default as IconSki } from './ski';
export { default as IconSmokeFree } from './smoke_free';
export { default as IconSnowRainShowers } from './snow_rain_showers';
export { default as IconSnowRain } from './snow_rain';
export { default as IconSnowSqualls } from './snow_squalls';
export { default as IconSnow } from './snow';
export { default as IconSocial } from './social';
export { default as IconSpa } from './spa';
export { default as IconSportingEvents } from './sporting_events';
export { default as IconStandardWifi } from './standard_wifi';
export { default as IconStorage } from './storage';
export { default as IconSunnyCloudy } from './sunny_cloudy';
export { default as IconSunny } from './sunny';
export { default as IconSupportStaff } from './support_staff';
export { default as IconSurfing } from './surfing';
export { default as IconSustainableFoodAndBeverage } from './sustainable_food_and_beverage';
export { default as IconSustainableTravel } from './sustainable_travel';
export { default as IconSwitchView } from './switch_view';
export { default as IconTablet } from './tablet';
export { default as IconTakeaway } from './takeaway';
export { default as IconTelephoneDirectory } from './telephone_directory';
export { default as IconTemperatureCheck } from './temperature_check';
export { default as IconTennis } from './tennis';
export { default as IconTermsAndConditions } from './terms_and_conditions';
export { default as IconTheatre } from './theatre';
export { default as IconThunderstormChance } from './thunderstorm_chance';
export { default as IconThunderstorm } from './thunderstorm';
export { default as IconTours } from './tours';
export { default as IconTownhouse } from './townhouse';
export { default as IconTrayRemoval } from './tray_removal';
export { default as IconTree } from './tree';
export { default as IconTreeLarge } from './tree_large';
export { default as IconTripadvisor } from './tripadvisor';
export { default as IconTurnDownService } from './turn_down_service';
export { default as IconTvChannelListings } from './tv_channel_listings';
export { default as IconTwitter } from './twitter';
export { default as IconUniqueStays } from './unique_stays';
export { default as IconUrban } from './urban';
export { default as IconUShape } from './u_shape';
export { default as IconValetParking } from './valet_parking';
export { default as IconVariableClouds } from './variable_clouds';
export { default as IconVegan } from './vegan';
export { default as IconVegetarian } from './vegetarian';
export { default as IconViews } from './views';
export { default as IconWasher } from './washer';
export { default as IconWasteReduction } from './waste_reduction';
export { default as IconWaterReduction } from './water_reduction';
export { default as IconWechat } from './wechat';
export { default as IconWeibo } from './weibo';
export { default as IconWellness } from './wellness';
export { default as IconWetSnow } from './wet_snow';
export { default as IconWhatsIncluded } from './whats_included';
export { default as IconWindy } from './windy';
export { default as IconWine } from './wine';
export { default as IconYacht } from './yacht';
export { default as IconYoga } from './yoga';
export { default as IconYouku } from './youku';
export { default as IconYoutube } from './youtube';
export { default as IconExpand } from './expand';
export { ArrowRight as IconArrowRight } from './arrow-right';
export { default as IconX } from './x';
export { default as IconFindContact } from './find_contact';
export { default as IconIllumeDashboard } from './illume_dashboard';
export { default as IconPreferredPartnerLogoHorizontal } from './pp-tree-logo-horizontal';
export { default as IconPreferredPartnerLogo } from './pp-logo';
export { default as IconFsTree } from './fs-tree';

// Credit Card Icons
export { default as Visa } from './visa';
export { default as Mastercard } from './mastercard';
export { default as Discover } from './discover';
export { default as AmericanExpress } from './american_express';
export { default as Jcb } from './jcb';
export { default as UnionPay } from './unionpay';
export { default as DinersClub } from './diners_club';
export { default as Alipay } from './alipay';
